/**
 * Service: Karat Deductions API
 * Manages communication with backend for karat rate deductions
 */

import api from '../../../services/api';

const BASE_URL = '/system/karat-deductions';

/**
 * Fetch all active karat deductions
 */
export const getAllDeductions = async () => {
  try {
    const response = await api.get(BASE_URL);
    console.log('✅ Loaded karat deductions:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching karat deductions:', error);
    throw error;
  }
};

/**
 * Fetch deduction for a specific karat
 * @param {string} karat - e.g., '22k'
 */
export const getDeductionByKarat = async (karat) => {
  try {
    const response = await api.get(`${BASE_URL}/${karat}`);
    return response.data;
  } catch (error) {
    console.error(`❌ Error fetching deduction for ${karat}:`, error);
    throw error;
  }
};

/**
 * Create a new karat deduction
 */
export const createDeduction = async (deductionData) => {
  try {
    const response = await api.post(BASE_URL, deductionData);
    return response.data;
  } catch (error) {
    console.error('❌ Error creating karat deduction:', error);
    throw error;
  }
};

/**
 * Update deduction for a specific karat
 * @param {string} karat - e.g., '22k'
 */
export const updateDeduction = async (karat, deductionData) => {
  try {
    const response = await api.put(`${BASE_URL}/${karat}`, deductionData);
    return response.data;
  } catch (error) {
    console.error(`❌ Error updating deduction for ${karat}:`, error);
    throw error;
  }
};

/**
 * Delete (soft delete) a karat deduction
 */
export const deleteDeduction = async (karat) => {
  try {
    const response = await api.delete(`${BASE_URL}/${karat}`);
    return response.data;
  } catch (error) {
    console.error(`❌ Error deleting deduction for ${karat}:`, error);
    throw error;
  }
};

/**
 * Initialize default deductions for all karats
 */
export const initializeDefaults = async () => {
  try {
    console.log('🔄 Initializing default deductions...');
    const response = await api.post(`${BASE_URL}/init-defaults`, {});
    console.log('✅ Defaults initialized:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error initializing defaults:', error);
    throw error;
  }
};

/**
 * Global % added on top of the website rate (after the website deduction)
 */
export const getWebsiteMarkup = async () => {
  const response = await api.get(`${BASE_URL}/website-markup`);
  return Number(response.data?.websiteMarkupPercent) || 0;
};

export const updateWebsiteMarkup = async (websiteMarkupPercent) => {
  const response = await api.put(`${BASE_URL}/website-markup`, { websiteMarkupPercent });
  return Number(response.data?.websiteMarkupPercent) || 0;
};
